export default "__VITE_PUBLIC_ASSET__23fafe95__"